<!--
 * @Author: 赵健
 * @Date: 2021-01-19 09:50:21
 * @LastEditTime: 2021-01-28 11:45:08
 * @LastEditors: 赵健
 * @Description: 权益管理
 * @FilePath: \trunk\src\views\merchantCenter\equityManage\index.vue
-->
<template>
  <div>
    <el-card shadow="never">
      <el-form
        :model="searchParam"
        :inline="true"
        label-width="100px"
      >
        <el-form-item label="权益板块:">
          <el-select
            v-model="searchParam.moduleId"
            style="width: 200px;"
            clearable
            placeholder="请选择权益名称"
          >
            <el-option
              v-for="item in moduleData"
              :key="item.moduleId"
              :label="item.sectionName"
              :value="item.moduleId"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="权益分类:">
          <el-select
            v-model="searchParam.classId"
            style="width: 200px;"
            clearable
            placeholder="请选择权益分类"
          >
            <el-option
              v-for="item in classData"
              :key="item.classId"
              :label="item.categoryName"
              :value="item.classId"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="权益名称:">
          <el-input
            v-model="searchParam.equityName"
            clearable
            style="width: 200px;"
            placeholder="请输入权益名称"
          />
        </el-form-item>

        <el-form-item label="是否需要预约:">
          <el-select
            v-model="searchParam.equityNeedAppointment"
            style="width: 200px;"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(value,key) in appointmentData"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
        </el-form-item>

        <el-form-item class="fr">
          <el-button
            type="primary"
            @click="getList('search')"
          >搜 索</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="flexBetween margin-t-20">
      <div>
        <el-radio-group
          v-model="searchParam.equityReviewStatus"
          @change="sendTabCode"
        >
          <el-radio-button :label="0">已上架({{ tabState.shelvesNum }})</el-radio-button>
          <el-radio-button :label="1">待上架({{ tabState.pendingNum||0 }})</el-radio-button>
          <el-radio-button :label="2">审核中({{ tabState.underReviewNum||0 }})</el-radio-button>
        </el-radio-group>
      </div>

      <div>
        <el-button
          type="primary"
          @click="$router.push({path:'/merchant/equityManage/add',query:{type:1}})"
        >新增权益</el-button>
      </div>
    </div>

    <el-card
      v-loading="loading"
      shadow="never"
    >
      <el-row :gutter="20">
        <el-col :span="4"><span class="tb-title">所属板块/分类</span></el-col>
        <el-col :span="12"><span class="tb-title">权益信息</span></el-col>
        <el-col :span="4"><span class="tb-title">是否需要预约</span></el-col>
        <el-col :span="4"><span class="tb-title">状态</span></el-col>
      </el-row>
      <div
        v-for="(item,index) in tableData"
        :key="index"
        class="margin-t-20 table-item"
      >
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="tb-value">{{ item.sectionName }}</div>
            <div class="tb-value">{{ item.categoryName }}</div>
          </el-col>
          <el-col :span="12">
            <div style="display:flex;">
              <img
                style="width:200px;height:100px;"
                :src="item.equityPictureUrl"
              >
              <div style="margin-left:10px;">
                <div>{{ item.equityName }}</div>
                <div style="color:#999;">{{ item.equityDescription }}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="4"><span class="tb-value">{{ item.equityNeedAppointment==0?'是':'否' }}</span></el-col>
          <el-col :span="4"><span class="tb-value">{{ item.equityReviewStatusName }}</span></el-col>
        </el-row>
        <div class="margin-t-20 table-menu">
          <i
            v-if="item.equityReviewStatus==1||item.equityReviewStatus==3"
            class="el-icon-edit colorBlue"
            @click="$router.push({path:'/merchant/equityManage/edit',query:{equityId:item.equityId,type:2}})"
          >修改权益</i>
          <i
            v-if="item.equityReviewStatus==1||item.equityReviewStatus==3"
            class="el-icon-delete-solid colorBlue"
            @click="deleteItem(item.equityId)"
          >删除权益</i>
          <i
            class="el-icon-s-order colorBlue"
            @click="$router.push({path:'/merchant/equityManage/info',query:{equityId:item.equityId}})"
          >权益详情</i>
          <i
            v-if="item.equityReviewStatus!=2"
            class="el-icon-user colorBlue"
            @click="$router.push({path:'/merchant/equityManage/relevance',query:{equityId:item.equityId}})"
          >关联会员</i>
          <i
            v-if="item.equityReviewStatus==1||item.equityReviewStatus==3"
            class="el-icon-upload2 colorBlue"
            @click="putAway(item.equityId)"
          >上架</i>
          <i
            v-if="item.equityReviewStatus==0"
            class="el-icon-download colorBlue"
            @click="soldOut(item.equityId)"
          >下架</i>
        </div>
      </div>
      <div
        v-if="!tableData.length"
        class="text-center margin-t-20 margin-b-20"
      >
        <img
          src="~@/assets/images/noData.svg"
          alt
          width="100"
        >
      </div>
      <pagination
        :total="listTotal"
        :page.sync="searchParam.page.pageNum"
        :limit.sync="searchParam.page.pageSize"
        background
        layout="total, prev, pager, next, sizes"
        @pagination="getList('page')"
      />
    </el-card>

    <el-dialog
      title="上架"
      :visible.sync="putAwayVisible"
      width="600px"
      destroy-on-close
      :append-to-body="true"
    >
      <el-form
        ref="putAwayForm"
        :model="putAwayForm"
        label-width="120px"
      >
        <el-form-item
          ref="equityRemark"
          label="上架说明:"
          prop="equityRemark"
          :rules="[
            {max:200,min:1, message: '长度在1到200个字符', trigger: 'change' },
          ]"
        >
          <el-input
            v-model="putAwayForm.equityRemark"
            style="width:100%"
            placeholder="请输入上架说明"
            maxlength="200"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
        <el-form-item
          ref="putOnFileList"
          label="附件:"
          prop="putOnFileList"
        >
          <um-upload v-model="putAwayForm.putOnFileList" :limit="5" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button type="primary" :loading="putAwayLoading" @click="putAwaySubmit">保 存</el-button>
        <el-button @click="putAwayVisible = false;$refs.putAwayForm.resetFields()">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  merchantEquityList,
  merchantEquityModuleParams,
  merchantEquityClassParams,
  merchantEquityDelete,
  merchantEquityOffShelf,
  merchantEquityPutOnSelf
} from '@/api/merchantCenter'
export default {
  name: 'MerchantEquityManage',
  data() {
    return {
      appointmentData: {
        '0': '需要',
        '1': '不需要'
      },
      loading: false,
      tabState: {}, // 状态数量
      moduleData: [], // 板块下拉框
      classData: [], // 分类下拉框
      tableData: [],
      listTotal: 0,
      searchParam: {
        equityReviewStatus: 0,
        equityNeedAppointment: null,
        moduleId: '',
        classId: '',
        equityName: '',
        page: {
          pageNum: 1,
          pageSize: 10
        }
      },
      putAwayVisible: false,
      putAwayLoading: false,
      putAwayForm: {
        equityId: null,
        equityRemark: '',
        putOnFileList: []
      }
    }
  },
  watch: {
    'searchParam.moduleId'(val) {
      this.searchParam.classId = null
      if (val) {
        this.getMerchantEquityClassParams()
      }
    }
  },
  created() {
    this.getMerchantEquityModuleParams()
  },
  // 页面缓存激活的时候刷新列表
  activated() {
    this.getList()
  },
  deactivated() {
    // 不是子路由的话做初始化
    if (this.$route.path.indexOf('/merchant/equityManage') === -1) {
      this.$store.dispatch('tagsView/delView', {
        name: 'MerchantEquityManage',
        path: '/merchant/equityManage'
      })
    }
  },
  methods: {
    async getMerchantEquityModuleParams() {
      const res = await merchantEquityModuleParams()
      this.moduleData = res.data.data
    },
    async getMerchantEquityClassParams() {
      const res = await merchantEquityClassParams({
        moduleId: this.searchParam.moduleId
      })
      this.classData = res.data.data
    },
    async getList(type) {
      if (type !== 'page') {
        this.searchParam.page.pageNum = 1
        this.searchParam.page.pageSize = 10
      }
      try {
        this.loading = true
        const res = await merchantEquityList(this.searchParam)
        this.tableData = res.data.list
        this.listTotal = res.data.page.total
        this.tabState = res.data.stateCount
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    sendTabCode(e) {
      this.searchParam.equityReviewStatus = e
      this.getList()
    },
    deleteItem(id) {
      this.$confirm('此操作将永久删除该权益, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          this.loading = true
          await merchantEquityDelete({ equityId: id })
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.loading = false
          this.getList()
        } catch (error) {
          this.loading = false
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    soldOut(id) {
      this.$confirm('是否确定下架该权益?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          this.loading = true
          await merchantEquityOffShelf({ equityId: id })
          this.$message({
            type: 'success',
            message: '下架成功!'
          })
          this.loading = false
          this.getList()
        } catch (error) {
          this.loading = false
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    putAway(id) {
      this.putAwayForm.equityId = id
      this.putAwayVisible = true
    },
    putAwaySubmit() {
      this.$refs.putAwayForm.validate(async valid => {
        if (valid) {
          try {
            this.putAwayLoading = true
            const file = this.putAwayForm.putOnFileList.map(i => i.filePath)
            await merchantEquityPutOnSelf(Object.assign({}, this.putAwayForm, { putOnFileList: file }))
            this.$message.success('操作成功')
            this.$refs.putAwayForm.resetFields()
            this.putAwayLoading = false
            this.putAwayVisible = false
            this.getList()
          } catch (e) {
            this.putAwayLoading = false
          }
        } else {
          this.$message.warning('请输入正确的表单！')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-item {
  padding-bottom: 10px;
  border-bottom: #e5e8f0 solid 1px;
}
.tb-title {
  color: #909399;
  font-weight: 500;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
}
.tb-value {
  color: #606266;
}
.table-menu {
  i {
    margin-right: 20px;
    cursor: pointer;
  }
}
.colorBlue {
  color: #409eff;
}
</style>
